export const statusVisuallyImpairedSelector = store => store.VisuallyImpaired.status;
